import React from 'react'
import Typography from '../../Typography'
import Button from '../../Button'

const TEXT = {
  byName: {
    text: 'By continuing, the user affirms that they are the legal guardian or close relative of the student whose image(s) they are requesting and that they authorize Shoob Photography to print and mail portraits of them to their home address.',
    button: 'Authorize Portrait Printing',
  },
  byAccessCode: {
    text: 'By continuing, the user affirms that they are the legal guardian or close relative of the student whose image(s) they are requesting and that they authorize Shoob Photography to display images of this student.',
    button: 'Authorize Image Display',
  },
}

const AccessCodeOnlyText = ({ byName = false }) => {
  const text = byName ? TEXT.byName : TEXT.byAccessCode

  return (
    <div>
      <Typography>{text.text}</Typography>
      <div style={{ marginTop: '12px' }}>
        <Button fullWidth variant="primary">{text.button}</Button>
      </div>
    </div>
  )
}

export default AccessCodeOnlyText
